module.exports = __webpack_public_path__ + "img/Abschnittsleiter_Betreuung.48680f96.svg";